export const initialFilterState = () => ({
  effectiveAt: null,
  processedBy: { value: [], isAll: true },
  searchType: "movementCode",
  page: 1,
  perPage: 10,
});
